import React from 'react';
import { Search } from 'lucide-react';
import { SearchByFilter } from '../GlobalSearch/SearchByFilter';
import type { ContactSearchBy } from '../../types/contactInsights';
export const contactSearchOptions: {
  value: ContactSearchBy;
  label: string;
  placeholder: string;
}[] = [{
  value: 'nameEmail',
  label: 'Name or Email',
  placeholder: 'Search by name or email'
}, {
  value: 'phone',
  label: 'Phone Number',
  placeholder: 'Search by phone number…'
}, {
  value: 'address',
  label: 'Address',
  placeholder: 'Search by address…'
}, {
  value: 'tag',
  label: 'Tag',
  placeholder: 'Search by tag…'
}, {
  value: 'product',
  label: 'Product purchased',
  placeholder: 'Search by product purchased…'
}, {
  value: 'club',
  label: 'Club Name',
  placeholder: 'Search by club name…'
}];
interface ContactSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  searchBy: ContactSearchBy;
  onSearchByChange: (value: ContactSearchBy) => void;
}

// Same size as the standard SearchBar, with the Search by icon at the right end
export function ContactSearchInput({
  value,
  onChange,
  searchBy,
  onSearchByChange
}: ContactSearchInputProps) {
  const placeholder = contactSearchOptions.find(option => option.value === searchBy)?.placeholder ?? 'Search by name or email';
  return <div className="relative w-full" data-id="element-1783" data-mp="19radysmyx3a2">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#94A3B8] pointer-events-none" data-id="element-1784" data-mp="19sbpszbt5tsu" />
      <input type="text" aria-label={placeholder} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} className="w-full h-10 pl-10 pr-11 bg-white border border-[#CBD5E1] rounded-md text-[14px] text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none focus:border-[#0EA5E9] focus:ring-2 focus:ring-[rgba(14,165,233,0.2)] transition-all duration-200" data-id="element-1785" data-mp="1iqx3ag2faimr" />
      <div className="absolute right-1 top-1/2 -translate-y-1/2" data-id="element-1786" data-mp="3pjfzqzmbe7qr">
        <SearchByFilter value={searchBy} onChange={onSearchByChange} options={contactSearchOptions} defaultValue="nameEmail" data-id="element-1787" data-mp="3uh989zb3bdu7" />
      </div>
    </div>;
}
export function matchesContactSearch(contact: {
  name: string;
  email: string;
  phone: string;
  address: string;
  tags: string[];
  subscriptionTitle: string;
  insights: {
    productsPurchased: string[];
  };
}, query: string, searchBy: ContactSearchBy): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const has = (text: string) => text.toLowerCase().includes(q);
  switch (searchBy) {
    case 'phone':
      {
        const digits = q.replace(/\D/g, '');
        return digits.length > 0 ? contact.phone.replace(/\D/g, '').includes(digits) : has(contact.phone);
      }
    case 'address':
      return has(contact.address);
    case 'tag':
      return contact.tags.some(has);
    case 'product':
      return contact.insights.productsPurchased.some(has);
    case 'club':
      return has(contact.subscriptionTitle);
    default:
      return has(contact.name) || has(contact.email);
  }
}